import React from "react";
import { CaretLeftIcon, CaretRightIcon } from "@phosphor-icons/react";

import Icon from "components/Icon/Icon";
import { PaginationWrapper } from "components/Pagination/styled"; // Reuse the same styled-component
import SkeletonLoader from "components/PageLoader/SkeletonLoader";

const Pagination = ({
  page,
  limit,
  totalCount,
  onPageChange,
  showResultsInfo = true,
  initialLoading = false
}) => {
  const totalPages = Math.ceil(totalCount / limit);
  const startItem = (page - 1) * limit + 1;
  const endItem = Math.min(page * limit, totalCount);

  const getPageNumbers = () => {
    const pages = [];
    const lastPage = totalPages;

    if (totalPages <= 5) {
      // Show all pages if 5 or fewer
      for (let i = 1; i <= lastPage; i++) pages.push(i);
    } else {
      // Always show first page
      pages.push(1);

      // Show left ellipsis if current page is far from start
      if (page > 3) pages.push("...");

      // Determine middle page numbers
      const startMiddle = Math.max(2, page - 1);
      const endMiddle = Math.min(lastPage - 1, page + 1);

      for (let i = startMiddle; i <= endMiddle; i++) {
        pages.push(i);
      }

      // Show right ellipsis if current page is far from end
      if (page < lastPage - 2) pages.push("...");

      // Always show last page
      pages.push(lastPage);
    }

    return pages;
  };

  return (
    <PaginationWrapper>
      {showResultsInfo && (
        <div className="pagination-info">
          {initialLoading ? (
            <SkeletonLoader width="150px" />
          ) : (
            <>
              Showing
              <p className="pagination-count">
                {startItem}-{endItem}
              </p>
              of {totalCount} results
            </>
          )}
        </div>
      )}

      <div className="pagination-controls">
        <>
          {/* Previous Button */}
          <div
            onClick={() => page > 1 && onPageChange(page - 1)}
            className={`prev-next-icon prev-icon ${
              page === 1 ? "disabled" : ""
            }`}
          >
            <Icon
              component={CaretLeftIcon}
              format="outline"
              weight="regular"
              color={page === 1 ? "#A5A5A5" : "#1F1F1F"}
            />
            Previous
          </div>

          {/* Page Numbers */}
          <div className="pagination-number">
            {initialLoading
              ? // Dynamic skeleton loader based on page count
                getPageNumbers().map((_, idx) => (
                  <SkeletonLoader key={idx} width="24px" height="24px" />
                ))
              : getPageNumbers().map((p, idx) =>
                  p === "..." ? (
                    <span key={idx} className="ellipsis">
                      ...
                    </span>
                  ) : (
                    <div
                      key={idx}
                      onClick={() => onPageChange(p)}
                      className={p === page ? "active number" : "number"}
                    >
                      {p}
                    </div>
                  )
                )}
          </div>

          {/* Next Button */}
          <div
            onClick={() => page < totalPages && onPageChange(page + 1)}
            className={`prev-next-icon next-icon ${
              page >= totalPages ? "disabled" : ""
            }`}
          >
            Next
            <Icon
              component={CaretRightIcon}
              format="outline"
              weight="regular"
              color={page >= totalPages ? "#A5A5A5" : "#1F1F1F"}
            />
          </div>
        </>
      </div>
    </PaginationWrapper>
  );
};

export default Pagination;
